import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { PlannedPurpose } from 'src/app/core/models/purpose';
import { Mongo } from 'src/app/core/models/mongo';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-planning-table-action-dialog',
    template: `
    <h4 class="text-center">{{ 'PLANNING.ACTIONS.EDIT' | translate }}</h4>
    
    <form [formGroup]="actionForm" class="row">
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>{{ 'PLANNING.SELECT' | translate }}</mat-label>
        <mat-select formControlName="benefitId">
          @for (benefit of data.benefitList; track benefit) {
            <mat-option [value]="benefit._id">{{ benefit.title }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>{{ 'PLANNING.ACTIONS.TITLE' | translate }}</mat-label>
        <input matInput formControlName="title" required />
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12">
        <mat-label>{{ 'PLANNING.ACTIONS.DESCRIPTION' | translate }}</mat-label>
        <textarea rows="6" matInput formControlName="description" required></textarea>
      </mat-form-field>
    </form>
    
    <section class="d-flex justify-content-center my-3">
      <button mat-flat-button mat-dialog-close>
        {{ 'CANCEL' | translate }}
      </button>
      <button [disabled]="!actionForm.valid" mat-flat-button color="accent" [mat-dialog-close]="actionForm.value">
        {{ 'CONFIRM' | translate }}
      </button>
    </section>
    `,
    styles: [':host { display: block; max-width: 500px}'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatInput, MatButton, MatDialogClose, TranslateModule]
})
export class PlanningTableActionDialogComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  data = inject<{
    action: PlannedPurpose.Action;
    benefitList: PlannedPurpose[];
    currentBenefit: Mongo.ObjectId;
}>(MAT_DIALOG_DATA);

  actionForm!: UntypedFormGroup;

  ngOnInit(): void {
    this.actionForm = this.fb.group({
      _id: [this.data.action._id],
      title: [this.data.action.title ?? '', Validators.required],
      description: [this.data.action.description ?? '', Validators.required],
      benefitId: [this.data.currentBenefit, Validators.required],
    });
  }
}
